import { Country, EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const BACSPaymentMethodSchema = z.object({
    last4: z.string(),
    accountHolderName: z.string(),
    bankName: z.string(),
    country: EnumSchema(Country).optional(),
});

export class BACSPaymentMethod extends FromSchema(BACSPaymentMethodSchema) {
    last4: string; // TBD - FS-1673
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    accountHolderName?: string;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore - Fix TS FS-3199
    bankName?: string;
    country?: Country;
}
